// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '../.components/index.vue'
import New from '../.components/new.vue'
import Edit from '../.components/edit.vue'

const main_router = 'status_prototypes'
const new_router = 'new_status_prototype'
const edit_router = 'edit_status_prototype'

const router = [
    {
        path: '',
        component: Index,
        name: 'status_prototypes',
        meta: {
            api_name: 'api_v1_provider_status_prototypes',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_status_prototype',
        meta: {
            api_name: 'api_v1_provider_status_prototypes_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity/edit',
        component: Edit,
        name: 'edit_status_prototype',
        meta: {
            api_name: 'api_v1_provider_status_prototypes_create',
            breadcrumb: [main_router, edit_router]
        }
    }
]

export default router
